<template>
  <div class="main-wrappers">

      <div style="display: flex; justify-content: start;">

        <div style="align-self: center;">
          Filter By Feature Flag:
          <b-dropdown
            variant="info"
            id="dropdown-feature-flag"
            :text="
              selectedFeatureKey
                ? getFeatureFlagLabel(selectedFeatureKey)
                : 'All '
            "
          >
            <b-dropdown-form>
              <b-form-input
                v-model="featureSearchQuery"
                placeholder="Search features..."
                size="sm"
              ></b-form-input>
            </b-dropdown-form>
            <b-dropdown-divider />
            <b-dropdown-item @click="filterByFeature('')">
              <strong>All</strong>
            </b-dropdown-item>
            <b-dropdown-divider />
            <div class="feature-dropdown">
            <b-dropdown-item
              @click="filterByFeature(item.key)"
              v-for="(item, index) in filteredFeatures"
              :key="index"
              v-bind:value="item"
              >{{ item.name }} ({{
                item.type === "location" ? "Location" : "Company"
              }})</b-dropdown-item
            >
            </div>
            <b-dropdown-text
              v-if="
                filteredFeatures.length === 0 && featureSearchQuery.trim() !== ''
              "
              class="text-muted text-center"
            >
              No features found
            </b-dropdown-text>
          </b-dropdown>
        </div>

        <div style="margin-left: 10px">
          Page Size:
          <b-dropdown variant="info" id="dropdown-1" right :text="pageSize" >
            <b-dropdown-item @click="pageSize = 10; page = 0; fetchData()" >10</b-dropdown-item>
            <b-dropdown-item @click="pageSize = 20; page = 0; fetchData()" >20</b-dropdown-item>
            <b-dropdown-item @click="pageSize = 50; page = 0; fetchData()" >50</b-dropdown-item>
          </b-dropdown>
        </div>

        <div class="ml-3" style="align-self: center;">
          <button
            :disabled="page === 0"
            class="btn btn-primary"
            @click="page = page - 1; fetchData()"
          >
            Previous page
          </button>
          <button
            :disabled="items.length < pageSize"
            class="btn btn-primary ml-2"
            @click="page = page + 1; fetchData()"
          >
            Next page
          </button>
        </div>

      </div>


      <br>

      <b-table :items="items" :fields="fields" :busy="isLoading" show-empty bordered striped head-variant="dark">
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>


        <template #cell(index)="row" >
          <div >
            <b>{{pageSize * page + row.index + 1}} </b>
          </div>
        </template>


        <template #cell(user)="row" >
          <div style="min-width: 200px;" c>
            <b>{{row.item.user.firstName}} {{row.item.user.lastName}}</b>
            <div class="toCapitalFirst">{{row.item.user.type}} - {{row.item.user.role}}</div>

            <div>
              <ClickToCopy style="font-size: 14px" :text="row.item.user.email" />
            </div>
          </div>
        </template>


        <template #cell(subject)="row" >
         <div style="min-width: 200px; text-align: left">
           <b>{{row.item.subject}} </b>
         </div>
        </template>


        <template #cell(description)="row">
          <div style="text-align: left; min-width: 500px;">
            {{row.item.description}}
          </div>
        </template>


        <template #cell(locationDetails)="row">
          <div style="text-align: center;  min-width: 300px;">
            <div v-if="row.item && row.item.locationDetails && row.item.locationDetails.name"><b>{{ row.item.locationDetails.name }}</b></div>
            <div v-else-if="row.item && row.item.companyDetails && row.item.companyDetails.name"><b>{{ row.item.companyDetails.name }}</b></div>
            <div v-if="row.item && row.item.locationDetails && row.item.locationDetails.email"><ClickToCopy :showTooltip="false" :text="row.item.locationDetails.email" /></div>
            <div v-else-if="row.item && row.item.companyDetails && row.item.companyDetails.email"><ClickToCopy :showTooltip="false" :text="row.item.companyDetails.email" /></div>

            <div v-if="row.item && row.item.locationDetails && row.item.locationDetails.id" style="font-size: 14px; margin-top: 10px; display: flex; justify-content: center;">
              <b>Location ID: </b>
              <ClickToCopy style="min-width: 150px; margin-left: 5px"  :showTooltip="false" :text="row.item.locationDetails.id" />
            </div>

            <div  v-if="row.item && row.item.companyDetails && row.item.companyDetails.id" style="font-size: 14px; display: flex; justify-content: center;">
              <b>Agency ID: </b>
              <ClickToCopy style="min-width: 150px; margin-left: 5px"  :showTooltip="false" :text="row.item.companyDetails.id" />
            </div>

            <div v-if="row.item && row.item.companyDetails && row.item.companyDetails.plan"  style="font-size: 14px; display: flex; justify-content: center;">
              <b>Plan: </b>
              <div style="margin-left: 5px" class="plan-pill"> {{row.item.companyDetails.plan}} </div>
            </div>

          </div>
        </template>


        <template #cell(attachments)="row" style="">
          <ul style="margin-left: 20px; min-width: 120px">
          <li v-if="row && row.item && row.item.attachments && row.item.attachments.length > 0"
               v-for="(attachment, index) in row.item.attachments" style="text-align: left">
            <a target="_blank" :href="attachment">Attachment {{index + 1}}</a>
          </li>
          </ul>
        </template>

        <template #cell(featureKey)="row">
          <div style="min-width: 150px">
            {{ getFeatureFlagLabel(row.item.featureKey) }}
              <div v-if="isFeatureFlagEnabled(row.item.featureFlags, row.item.featureKey)"
                   :class='`feature-flag-status feature-flag-${isFeatureFlagEnabled(row.item.featureFlags, row.item.featureKey)}`'>
                {{ isFeatureFlagEnabled(row.item.featureFlags, row.item.featureKey) }}
              </div>
          </div>
        </template>

        <template #cell(createdAt)="row">
          <div style="min-width: 150px;">
            {{ formatTime(row.item.createdAt) }}
          </div>
        </template>



      </b-table>
  </div>
</template>

<script>
import ClickToCopy from "@/components/common/ClickToCopy";
import LocationsService from "@/services/LocationsService";
import * as moment from "moment";
import * as _ from 'lodash';

export default {
  components:{
    ClickToCopy
  },
  data() {
    return {
      fields: [
        {key: 'index', label: 'No.'},
        {key: 'user', label: 'User Details'},
        {key: 'subject', label: 'Subject'},
        {key: 'description', label: 'Description'},
        {key: 'attachments', label: 'Attachments'},
        {key: 'locationDetails', label: 'Location/ Company Details'},
        {key: 'createdAt', label: 'When'},
        {key: 'featureKey', label: 'Feature Key'},
      ],
      features: [],
      selectedFeatureKey: '',
      items: [],
      pageSize: 20,
      page: 0,
      isLoading: false,
      featureSearchQuery: "",
    }
  },
  computed: {
    filteredFeatures() {
      if (!this.featureSearchQuery.trim()) {
        return this.features;
      }
      const query = this.featureSearchQuery.toLowerCase().trim();
      return this.features.filter(
        (feature) =>
          feature.name.toLowerCase().includes(query) ||
          feature.key.toLowerCase().includes(query) ||
          feature.type.toLowerCase().includes(query)
      );
    },
  },
  async created() {
    this.isLoading = true;
    this.features = [
      ...(await LocationsService.getLabsFeatures('location')).data,
      ...(await LocationsService.getLabsFeatures('company')).data
    ];
    await this.fetchData()
    this.isLoading = false;
  },
  methods: {
    getFeatureFlagLabel(featureKey){
      const feature = this.features.find((f)=> f.key === featureKey)
      return feature ? `${feature.name} ( ${feature.type == 'location'? 'Location': 'Company'}) ` : featureKey
    },
    isFeatureFlagEnabled(featureFlags, key){
      const flag = _.get(featureFlags, key);
      if(flag === undefined){
        return 'default'
      }else if(flag){
        return 'enabled'
      }else{
        return 'disabled'
      }
    },
    async fetchData() {
      try {
        this.isLoading = true;
        const skip = this.page * this.pageSize
        const resp = await LocationsService.searchFeatureFeedbacks(this.selectedFeatureKey, skip, this.pageSize)

        this.items = resp.data.feedbacks;
        this.isLoading = false
      } catch(error){
        console.error(error);
        alert(JSON.stringify(error));
      }
    },
    async filterByFeature(key){
      this.selectedFeatureKey = key
      this.page = 0;
      await this.fetchData()
    },
    formatTime(time){
      return moment(time).format(
        "DD MMM YY - HH:mm"
      )
    }
  }
};
</script>

<style scoped>
.main-wrapper {
  margin: 30px auto;
  width: 90%;
}
.main-wrapper .table-responsive-sm .table thead th {
  background: #333;
  color: #fff;
}

.toCapitalFirst {
  text-transform: capitalize;
}

.plan-pill{
  border: 1px solid red;
  background: #ffc1c1;
  padding: 0px 7px;
  border-radius: 13px;
  color: black;
}

.feature-flag-status{
  width: fit-content;
  padding: 3px 25px;
  margin: 5px auto;
}

.feature-flag-enabled{
  text-transform: capitalize;
  border: 1px solid #57a514;
  background: #57a51469;
  border-radius: 13px;
  color: black;
}


.feature-flag-disabled{
  text-transform: capitalize;
  border: 1px solid red;
  background: #ffc1c1;
  border-radius: 13px;
  color: black;
}

.feature-flag-default{
  text-transform: capitalize;
  border: 1px solid #1460a5;
  background: #1460a569;
  border-radius: 13px;
  color: black;
}

#dropdown-feature-flag /deep/ .feature-dropdown {
  height: 500px;
  width: 500px;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
